module.exports = __webpack_public_path__ + "static/media/rpm.28f0b612.svg";